"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import { SliderCard as SliderCardType } from "@/types";
import { CarouselNav } from "@/components/util/carousel-nav";
import { SlideCard } from "./slide-card";
import { sliderVariants } from "./slider.variants";

type SliderSwiperProps = {
  list: SliderCardType[];
};

export const SliderSwiper = (props: SliderSwiperProps) => {
  const { list } = props;
  const styles = sliderVariants();
  const swiperId = "slider-swiper";

  return (
    <>
      <Swiper
        speed={200}
        autoHeight={false}
        simulateTouch={false}
        modules={[Pagination, EffectFade, Autoplay, Navigation]}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        navigation={{
          prevEl: `.prev-carousel-${swiperId}`,
          nextEl: `.next-carousel-${swiperId}`,
        }}
        effect={"fade"}
        spaceBetween={0}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1023: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1260: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }}
        className={styles.slider({ className: `${swiperId}-slider` })}
      >
        {list.map((item) => (
          <SwiperSlide key={`${swiperId}-item-${item.id}`} className={styles.slide()}>
            <SlideCard data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <CarouselNav swiperId={swiperId} />
    </>
  );
};
